module.exports = __webpack_public_path__ + "img/295.25bca7bb.png";